module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/document/document.component.css
// module id = ./src/app/document/document.component.css
// module chunks = main